import { render } from "./StatCardWidget.vue?vue&type=template&id=8b3036ca&ts=true"
import script from "./StatCardWidget.vue?vue&type=script&lang=ts"
export * from "./StatCardWidget.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/AreaClienti_SELENIA/AreaClienti_SELENIA/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__